import { callGetBannerBank } from '../../services/BannerService';
import {
  BANNER_ERROR,
  BANNER_LOADING,
  BANNER_SUCCESS,
} from '../types/BannerTypes';

const loadBanner = () => {
  return {
    type: BANNER_LOADING,
  };
};

const errorInBanner = () => {
  return {
    type: BANNER_ERROR,
  };
};

const setBanner = (banner) => {
  return {
    type: BANNER_SUCCESS,
    banner,
  };
};

export const getBannerBankAction = () => {
  return async (dispatch) => {
    dispatch(loadBanner());
    try {
      const response = await callGetBannerBank();
      if (response.status !== 200) {
        dispatch(errorInBanner());
      } else {
        dispatch(setBanner(response?.data));
      }
    } catch (error) {
      dispatch(errorInBanner());
    }
  };
};
